"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const ImageButton_1 = __importDefault(require("./ImageButton"));
function NavButton(props) {
    const { className } = props, others = __rest(props, ["className"]);
    const classes = `ui-nav-button px-5 py-2 h-11 font-medium text-sm bg-white hover:text-white hover:bg-[#42852c] ${className ? className : ""}`;
    return ((0, jsx_runtime_1.jsx)(ImageButton_1.default, Object.assign({ className: classes }, others)));
}
